import type { ChatbotApi } from '@liks/backend-svc-api/esm/apis/ChatbotApi';
import type {
  ChatbotConversationWithIdentity,
  ChatbotMessageWithIdentity,
} from '../types/chatbot';
import {
  hasConversationIdentity,
  hasMessageIdentity,
} from './chatbotServiceGuards';

export async function listConversations(
  chatbotApi: ChatbotApi,
  chatbotId: string,
  options: { limit?: number; offset?: number } = {},
): Promise<ChatbotConversationWithIdentity[]> {
  const conversations =
    await chatbotApi.deLiksChatbotBoundaryChatbotConversationResourceListChatbotConversations(
      {
        chatbotId,
        limit: options.limit ?? 1000,
        offset: options.offset ?? 0,
      },
    );
  return conversations.filter(hasConversationIdentity);
}

export async function getConversation(
  chatbotApi: ChatbotApi,
  chatbotId: string,
  conversationId: string,
): Promise<ChatbotConversationWithIdentity> {
  const conversation =
    await chatbotApi.deLiksChatbotBoundaryChatbotConversationResourceReadChatbotConversation(
      {
        chatbotId,
        id: conversationId,
      },
    );

  if (!hasConversationIdentity(conversation)) {
    throw new Error('Backend returned a conversation without id');
  }

  return conversation;
}

export async function listConversationMessages(
  chatbotApi: ChatbotApi,
  chatbotId: string,
  conversationId: string,
  options: { limit?: number; offset?: number } = {},
): Promise<ChatbotMessageWithIdentity[]> {
  const messages =
    await chatbotApi.deLiksChatbotBoundaryChatbotConversationResourceListChatbotMessages(
      {
        chatbotId,
        id: conversationId,
        limit: options.limit ?? 1000,
        offset: options.offset ?? 0,
      },
    );
  return messages.filter(hasMessageIdentity);
}
